<template>
    <div>
        <div v-if="erro">
            <SemPermissao></SemPermissao>
        </div>
        <template v-if="!erro">
            <PerguntaForm :pergunta="null" />
        </template>
    </div>
</template>

<script>

    import PerguntaForm from '../../components/perguntas/PerguntaForm.vue';
    import SemPermissao from "../SemPermissao.vue"

    export default {
        name: "PerguntaNew",
        data() {
            return {
                erro: false,
            };
        },
        components: {
            SemPermissao,
            PerguntaForm,
        },
    };
</script>

<style lang="scss" scoped>
</style>